document.addEventListener('DOMContentLoaded', function() {
  const quickAddButtons = document.querySelectorAll('.quick-add-button');
  
  quickAddButtons.forEach(button => {
    button.addEventListener('click', function(e) {
      e.preventDefault();
      const productId = this.getAttribute('data-product-id');
      
      // Add to cart via Shopify AJAX API
      fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          id: productId,
          quantity: 1
        })
      })
      .then(response => response.json())
      .then(data => {
        // Success - update cart or show notification
        console.log('Product added to cart:', data);
        // You can add custom notification here
        alert('Product added to cart!');
        
        // Optionally refresh cart drawer/count
        if (window.theme && window.theme.cart) {
          window.theme.cart.refresh();
        }
      })
      .catch(error => {
        console.error('Error adding to cart:', error);
        alert('Error adding product to cart');
      });
    });
  });
});
